import { z } from 'zod';
import { CanvasImageValue } from '../../types/utils';

/**
 * A freshly cropped image lives in form state as an `HTMLCanvasElement` until
 * the submit handler uploads it and swaps in the returned URL.
 *
 * The runtime check is `instanceof HTMLCanvasElement`; only the static type is
 * narrowed to {@link CanvasImageValue}. Keeping the DOM type out of the
 * inferred form type matters: react-hook-form's `Path<T>` recurses into every
 * object type that is not `Date | FileList | File`, and one `HTMLCanvasElement`
 * field expands the whole DOM type graph — measured at ~40 minutes of `tsc`.
 */
export const canvasImageSchema = z.custom<CanvasImageValue>(
  // eslint-disable-next-line no-undef
  (value) => value instanceof HTMLCanvasElement,
  { message: 'Expected an HTMLCanvasElement' }
);

/** A cropped canvas, an already-uploaded URL, or nothing yet. */
export const canvasImageOrUrlSchema = z.union([
  canvasImageSchema,
  z.string(),
  z.null(),
]);
